module.exports = __webpack_public_path__ + "img/Group 98.a7a99066.svg";